import { useState } from 'react'
import { type UseFormReturn } from 'react-hook-form'

type AddressForm = Pick<UseFormReturn<any>, 'setValue' | 'getValues'>

export type AutofillCoordinates = { latitude: number; longitude: number }

export function useAddressAutofill(form: AddressForm) {
  const [coordinates, setCoordinates] = useState<AutofillCoordinates | null>(null)

  const handleAutofillRetrieve = (response: any) => {
    const feature = response.features[0]
    if (!feature) return
    const { properties, geometry } = feature
    form.setValue('address_line_1', properties.address_line1 || form.getValues('address_line_1'))
    form.setValue('address_line_2', properties.address_line2 || form.getValues('address_line_2'))
    form.setValue('city', properties.address_level2 || form.getValues('city'))
    form.setValue('state', (properties.address_level1 || '').slice(0, 2).toUpperCase())
    form.setValue('postal_code', properties.postcode || form.getValues('postal_code'))
    form.setValue('country', properties.country_code?.toUpperCase() || 'USA')
    if (geometry?.coordinates) {
      setCoordinates({ longitude: geometry.coordinates[0], latitude: geometry.coordinates[1] })
    }
  }

  return { handleAutofillRetrieve, coordinates }
}